declare namespace $ {

	type $mol_view__sub_bog_fragile_demo_collide_child1_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_fragile_demo_collide_child1 extends $bog_fragile_demo_collide_base1 {
		icon( ): string
		Attach( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=child1.view.tree.d.ts.map